import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { ApiResponse } from '../models/ApiResponse';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PolicyService {
  constructor(private http: HttpClient) {
    
   }

  async PolicyDetailsById1(policyId:string = "", applicationId:string = "", quoteId:string = "", policyIdEnc:string = "") {
    return this.http.get<ApiResponse>(`${environment.APIUrl}policy/PolicyDetailsById1?policyId=${policyId}&applicationId=${applicationId}&quoteId=${quoteId}&policyIdEnc=${policyIdEnc}`, {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
    }).toPromise().catch(async (errorRes: any) => {
      return errorRes;
    });   
  }

  async DownloadPolicy(policyId:any) {
    return this.http.get<ApiResponse>(`${environment.WebPortalAPIUrl}policy/DownloadPolicy?p=${policyId}`,  {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set('NoAuthorization', 'True')
    }).toPromise().catch(async (errorRes: ApiResponse) => {
      let res = new ApiResponse();
      res.isSuccess = false;
      res.message = errorRes.message;
      return res;
    });
  }

  async PolicyDetailsFilteredByPolicyId1(policyIdEnc:string) {
    return this.http.get<ApiResponse>(`${environment.WebPortalAPIUrl}policy/PolicyDetailsFilteredByPolicyId1?p=${policyIdEnc??""}`, {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
    }).toPromise().catch(async (errorRes: any) => {
      return errorRes;
    });
  }
  
    async saveOldPolicy(data: any) {
    return this.http.post<ApiResponse>(`${environment.WebPortalAPIUrl}policy/SaveOldPolicy`, data, {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
    }).toPromise().catch(async (errorRes: ApiResponse) => {
      let res = new ApiResponse();
      res.isSuccess = false;
      res.message = errorRes.message;
      return res;
    });
  }
}
